import { AxiosError } from 'axios';
import type { LoggedInUser } from '../../types/auth.types';
import type { WhatsAppEntryStatus } from '../../types/whatsappEntry.types';
import newAPIService from './newAPIService';

export type WhatsAppEntryPasswordlessResult = {
    authenticated: true
    user: LoggedInUser
};

export type WhatsAppEntryLinkResult = {
    linked: true
    conversationTransferred: boolean
};

function getWhatsAppEntryError(error: unknown): Error {
    const responseData = (error as AxiosError)?.response?.data;
    if (typeof responseData === 'string' && responseData) return new Error(responseData);
    return new Error('לא ניתן להשלים את קישור חשבון ה־WhatsApp. יש לנסות שוב.');
}

export async function getWhatsAppEntryStatus(token: string): Promise<WhatsAppEntryStatus> {
    try {
        const response = await newAPIService.get<WhatsAppEntryStatus>(
            '/api/whatsapp-entry/status',
            { params: { token } },
        );
        return response.data;
    } catch (error) {
        throw getWhatsAppEntryError(error);
    }
}

export async function loginWithWhatsAppEntry(
    token: string,
    confirmAccountSwitch = false,
): Promise<WhatsAppEntryPasswordlessResult> {
    try {
        const response = await newAPIService.post<WhatsAppEntryPasswordlessResult>(
            '/api/whatsapp-entry/passwordless',
            { token, confirmAccountSwitch },
        );
        return response.data;
    } catch (error) {
        throw getWhatsAppEntryError(error);
    }
}

export async function linkWhatsAppEntry(token: string): Promise<WhatsAppEntryLinkResult> {
    try {
        const response = await newAPIService.post<WhatsAppEntryLinkResult>(
            '/api/whatsapp-entry/link',
            { token },
        );
        return response.data;
    } catch (error) {
        throw getWhatsAppEntryError(error);
    }
}

export async function cancelWhatsAppEntry(token: string): Promise<void> {
    try {
        await newAPIService.post('/api/whatsapp-entry/cancel', { token });
    } catch (error) {
        throw getWhatsAppEntryError(error);
    }
}

export async function logoutForWhatsAppAccountSwitch(): Promise<void> {
    await newAPIService.get('/app-logout');
}
